"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const schema_1 = require("../../common/appointment/schema");
exports.default = {
    type: "object",
    properties: {
        missedVisitDate: {
            type: "number",
            format: "date",
            disableFuture: true,
        },
        reason: {
            type: "string",
        },
        futureAppointment: (0, schema_1.makeAppointmentSchema)({
            disablePast: true,
        }),
        notes: { type: "string", title: "Notes", maxLength: 3000 },
    },
    required: ["missedVisitDate", "reason"],
};
